<template>
  <div class="Activity_selfhelp">
    <div class="Activity_selfhelp_top">
      <el-form :inline="true" :model="from" class="demo-form-inline">
        <el-form-item label="活动主题">
          <el-input v-model="from.subject" placeholder="活动主题"></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker v-model="from.times"   value-format="yyyy-MM-dd"  type="date"  placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button type="primary" @click="resetfun()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="width: 100%;height: 14px;background-color: #fff"></div>

    <div class="Activity_selfhelp_nav" style="height: calc(100% - 120px);background-color: #fff;margin-top:14px;">
      <div class="Activity_selfhelp_nav_top">

        <div style="width: 100%;height: 40px;">
          <el-button @click="dialogVisible = true" type="primary" style="margin-top:10px">新建课目</el-button>
          <el-button @click="delfun()">删除</el-button>
        </div>

        <div style="height: calc(100% - 135px);background-color: #fff;">
          <div style="width: calc(100% - 620px); margin-top: 20px;height: 100%;float: left;">
            <el-table :data="tableData" style="width: 100%;" :row-key="(row) => { return row.eventKey; }"  @selection-change="handleSelectionChange">

              <el-table-column type="selection"  width="55"></el-table-column>

              <el-table-column prop="date" label="内容封面" >
                <template slot-scope="scope">
                  <img :src="scope.row.coverPath" alt="" style="width: 80px;height: 50px;">
                </template>
              </el-table-column>
              <el-table-column prop="subject" label="课目名称"></el-table-column>
              <el-table-column prop="evenContent" label="课程说明"></el-table-column>
              <el-table-column prop="isActive" label="状态">
                <template slot-scope="scope">
                  <span>{{ scope.row.isActive == 1 ? '有效' : '已结束' }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="syncChart" label="同步论坛">
                <template slot-scope="scope">
                  <span>{{ scope.row.syncChart == 1 ? '是' : '否' }}</span>
                </template>
              </el-table-column> -->
              <el-table-column prop="createTime" label="创建时间"></el-table-column>
              <el-table-column prop="syncChart"  label="操作">

                <template slot-scope="scope">
                  <span class="w" @click="edits(scope.row)">修改</span>
                  <span class="w" @click="looks(scope.row)">查看</span>
                  <span class="w" @click="downs(scope.row)">下架</span>
                </template>

              </el-table-column>
            </el-table>
            <div class="block">
              <el-pagination @current-change="handleCurrentChange" :current-page="from.pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts">
              </el-pagination>
            </div>
          </div>

          <div v-if="rigjh" style="width: 600px; height: 100%;float: right;margin-top: 20px;margin-left: 20px;">
            <div style="position: relative;border-bottom: 1px solid rgba(225, 226, 227, 1);height: 80px;">
              <h2 style="position: absolute;top:0px;left: 10px;font-size: 16px;">课程:{{ onlineEventPlan.subject }}</h2>
              <el-button style="position: absolute;right: 40px;"  @click="dialogVisible2 = true" type="primary">添加素材</el-button>
              <ul style="position: absolute;top: 40px;">
                <li style="float: left;margin-left: 10px;">素材数量：{{ onlineEventPlan.attachCount }}</li>
                <li style="float: left;margin-left: 40px;">点赞：   {{ onlineEventPlan.likeCount }}</li>
                <li style="float: left;margin-left: 40px;">观看人数：{{ onlineEventPlan.viewCount }}</li>
              </ul>
            </div>

            <el-table :data="tableData2" style="width: 100%;margin-top: 20px;" >
              <el-table-column prop="fileNM" label="素材名称"></el-table-column>
              <el-table-column prop="path" label="素材内容"></el-table-column>
              <el-table-column prop="syncChart" label="操作">
                <template slot-scope="scope">
                  <span class="w" @click="edits2(scope.row)">修改</span>
                  <span class="w" @click="downs2(scope.row)">删除</span>
                </template>
              </el-table-column>
            </el-table>

            <div class="block">
              <el-pagination @current-change="handleCurrentChange2" :current-page="from.pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts2">
              </el-pagination>
            </div>
          </div>
        </div>
        
      </div>
    </div>

    <el-dialog :title="tits" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
      <el-form :model="ruleForm" style="width: 500px;" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

        <el-form-item label="课程名称" prop="subject">
          <el-input v-model="ruleForm.subject" placeholder="课程名称"></el-input>
        </el-form-item>

        <el-form-item label="内容分类" prop="classification">
          <el-select v-model="ruleForm.classification" placeholder="内容分类">
            <el-option v-for="(item,i) in campus_list" :key="i" :label="item.cDicValue"
                :value="item.dicKey">
              </el-option>
            </el-select>
        </el-form-item>
 
        <!-- <el-form-item label="同步论坛" prop="syncChart">
          <el-switch v-model="ruleForm.syncChart"></el-switch>
        </el-form-item> -->

        <el-form-item label="课程说明" prop="eventContent">
          <el-input type="textarea" v-model="ruleForm.eventContent" placeholder="课程说明"></el-input>
        </el-form-item>

        <el-form-item label="课程封面" prop="coverPath">

          <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"  accept=".jpg, .jpeg, .png">
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon">
              <span style="font-size: 16px;">点击选择文件</span>
            </i>
          </el-upload>
          <p style="margin-left: 240px;color: #606266;">课程封面建议使用200*200分辨率小于500K的图片，支持.jpg、png格式。</p>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="anload" @click="submitForm('ruleForm')">{{ atype }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :title="tits2" :visible.sync="dialogVisible2" width="30%" :before-close="handleClose">

      <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">

        <el-form-item label="素材名称" prop="fileNM">
          <el-input v-model="ruleForm2.fileNM" placeholder="请输入素材名称"></el-input>
        </el-form-item>

        <el-form-item label="素材类型" >
          <el-radio-group v-model="ruleForm2.fileType">
            <el-radio label="3">视频</el-radio>
            <el-radio label="4">音频</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="时长" prop="duration">
          <el-input v-model="ruleForm2.duration" placeholder="请输入素材时长"></el-input>
        </el-form-item>

        <el-form-item label="上传文件" prop="fbShiping">
          <el-upload 
            style="background-color: rgba(0, 136, 255, 1);height: 42px;padding: 0px 20px;color: aliceblue;width: 60px;" 
            :auto-upload="false" 
            class="avatar-uploader" 
            action="" 
            :show-file-list="false" 
            :on-success="videohandleAvatarSuccess" 
            :on-change="videohandleChange"  
            accept=".mp3, .avi, .mov, .mp4">
             {{ruleForm2.fileType=='3'?'上传视频':'上传音频'}}
          </el-upload>
          <p style="margin-left: 120px;color: #606266;line-height: 18px;font-size: 14px;">点击这里上传您的文件。我们支持mp3、mp4、AVI格式。文件大小限制为500MB</p>
          <div>{{fileNMs}}</div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="addcourseloading" @click="submitForm2('ruleForm2')">{{ tits3 }} </el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
  </div>
</template>
<script>

  export default {
    data() {
      return {
        anload:false,
        fileNMs:'',
        atype: '立即创建',
        tits: '新增课目',
        tits2: '添加课程',
        tits3: '立即创建',
        eventAttachKey:'',
        rigjh:false,
        Counts: 0,
        Counts2: 0,
        currentEventKey:'',
        eventKey:'',//删除
        eventKeys: [],//删除
        dialogVisible:false,
        dialogVisible2:false,
        addcourseloading:false,
        from: {
          pageSize: 10,
          pageIndex: 1,
          holdType: 2,//举办方式 0代表全部 1线下发布或者立项  2代表自助活动 默认为0；
          eventType: 0,//活动类型 0全部 1全部 2全部 开始查询默认为2
          eventStatus: 0,//1-立项 2-审核中 3-审核通过 4-驳回修改 5-拒绝 6-发布
          subject: '',//活动主题
          subjectTime: '',//活动日期
          times: '',//创建时间（查询自助活动用）
        },
        ruleForm: {
          subject:'',
          classification:'',
          syncChart:false,
          eventContent:'',
          coverPath:'',
        },
        ruleForm2: {
          fileNM: '',//素材名称
          eventKey: '',//活动编号
          fbShiping: '',//附件文件
          duration: '',//时长
          fileType: '3', //3-视频 4-音频
        },
        imageUrl: '',
        campus_list: [],//科目内容分类
        tableData: [],
        tableData2: [],
        onlineEventPlan: '',
        pageIndex:1,
        rules: {
          name: [
            { required: true, message: '请输入课程名称', trigger: 'blur' },
          ],
          classification: [
            { required: true, message: '请选择内容分类', trigger: 'change' }
          ],
          eventContent: [
            { required: true, message: '请填写活动内容', trigger: 'blur' }
          ],
          coverPath: [
            { required: true, message: '请选择封面', trigger: 'blur' },
          ]
        },
        rules2: {
          fileNM: [
            { required: true, message: '请输入课程名称', trigger: 'blur' },
          ],
          duration: [
            { required: true, message: '请输入时长', trigger: 'blur' },
          ],
          fbShiping: [
            { required: true, message: '请上传文件', trigger: 'change' },
          ]
        },

      };
    },
    watch:{
      dialogVisible(val){
        if(!val){
          this.ruleForm=this.$options.data().ruleForm;
          this.imageUrl = '';
          this.$refs.ruleForm.resetFields();
        }
      },
      dialogVisible2(val){
        if(!val){
          this.ruleForm2=this.$options.data().ruleForm2;
          this.fileNMs = '';
          this.$refs.ruleForm2.resetFields();
        }
      }
    },
    methods: {
      onSubmit() {
        
        this.loading()
      },
      resetfun() {
        this.from = {
          pageSize: 10,
          pageIndex: 1,
          holdType: 2,//举办方式 0代表全部 1线下发布或者立项  2代表自助活动 默认为0；
          eventType: 0,//活动类型 0全部 1全部 2全部 开始查询默认为2
          eventStatus: 0,//1-立项 2-审核中 3-审核通过 4-驳回修改 5-拒绝 6-发布
          subject: '',//活动主题
          subjectTime: '',//活动日期
          times: '',//创建时间（查询自助活动用）
        },
        this.loading()
      },
      looks(row) { 
        this.currentEventKey=row.eventKey;
        this.ruleForm2.eventKey = row.eventKey;
        this.rigjh = true;
        this.loading2();
      },

      loading2() {
        this.$Http_Post('/activitymanagement/geteventattachlist', { 
          eventKey: this.ruleForm2.eventKey, 
          pageIndex: this.pageIndex, 
          pageSize: '10'}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            if (res.Data) {
              this.tableData2 = res.Data.tgEventAttachList;
              this.onlineEventPlan = res.Data.onlineEventPlan;
              this.Counts2 = res.Counts;
            } else {
              this.tableData2 = res.Data.tgEventAttachList;
              this.onlineEventPlan = '';
              this.Counts2 = res.Counts;
            }
          } else {
            this.Global.request_failure(res.Message);
          }
        })
      },

      downs2(row){
        this.ruleForm2.eventKey = row.eventKey;
        this.$Http_Post('/activitymanagement/deleventattach', { eventAttachKey: row.eventAttachKey }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.loading2();
          }else{
            this.Global.request_failure(res.Message);
          }
        })
      },

      edits2(row) {
        this.eventAttachKey = row.eventAttachKey
        this.$Http_Post('/activitymanagement/fxeventattach', { eventAttachKey: row.eventAttachKey }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.ruleForm2.fileNM = res.Data.fileNM;
            this.ruleForm2.duration = res.Data.duration;
            this.ruleForm2.fileType = res.Data.fileType.toString();
            this.fileNMs = res.Data.fileName;
            this.ruleForm2.eventKey = res.Data.eventKey;
            this.tits3 = "立即修改";
            this.dialogVisible2 = true;
          } else {
            this.Global.request_failure(res.Message);
          }
        })
      },
      edits(row) {
        this.eventKey = row.eventKey;
        this.$Http_Post('/activitymanagement/fxonlineeventplan', { eventKey: row.eventKey }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.dialogVisible = true
            this.tits = "查看与修改"
            this.atype = "立即修改"
            this.ruleForm = {
              subject: res.Data.subject,
              classification: res.Data.classification.toString(),
              syncChart: res.Data.syncChart == 1?true:false,
              eventContent: res.Data.evenContent,
              coverPath: res.Data.coverPath,
            }
            this.imageUrl = res.Data.coverPath;
          }
        })
      },
      downs(row) {
        this.$Http_Post('/activitymanagement/offshelfonlineevent', { eventKey: row.eventKey }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.loading();
          } else {
            this.Global.request_failure(res.Message);
          }
        })
      },
      handleCurrentChange(val) {
        this.from.pageIndex = val;
        this.loading();
      },
      handleCurrentChange2(val) {
        this.pageIndex = val;
        this.loading2();
      },
      handleSelectionChange(val) {
        var lsc = [];
        for (var i = 0; i < val.length; i++) {
          lsc.push(val[i].eventKey);
        }
        this.eventKeys = lsc;
      },

      delfun(){
        if(this.eventKeys.length>=1){
          var from = {
            eventKeys:this.eventKeys
          }
          this.$Http_Post('/activitymanagement/deeventplan', { from: from }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message);
              this.loading();
            }else{
              this.Global.request_failure(res.Message);
            }
          })
        }else{
          this.Global.request_failure('请选择删除项！');
        }
      },
      loading() {
        this.$Http_Post('/activitymanagement/geteventplanlist', { from: this.from }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Counts = res.Counts;
            this.tableData = res.Data;
            this.loadings = false;
          }
        })
      },
      submitForm(formName) {//新建课目
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.atype == '立即创建') {
              this.anload = true
              var from = new FormData();
              from.append('coverPath', this.ruleForm.coverPath.raw);
              from.append('subject', this.ruleForm.subject);
              from.append('classification', this.ruleForm.classification);
              from.append('eventContent', this.ruleForm.eventContent);
              from.append('syncChart', this.ruleForm.syncChart ? 1 : 0);
              this.$Http_Post('/activitymanagement/addonlineevent', from, { 'Content-Type': 'multipart/form-data'}).then((res) => {
                this.anload = false;
                if (res.Code == 200 || res.Code == 0) {
                  this.ruleForm=this.$options.data().ruleForm;
                  this.Global.request_successful(res.Message);
                  this.dialogVisible = false;
                  this.loading();
                } else {
                  this.Global.request_failure(res.Message);
                }
              })
            } else {
              this.anload = true;
              var from = new FormData();
              from.append('sxfb','1');
              from.append('eventKey', this.eventKey);
              from.append('coverPath', this.ruleForm.coverPath.raw);
              from.append('subject', this.ruleForm.subject);
              from.append('classification', this.ruleForm.classification);
              from.append('eventContent', this.ruleForm.eventContent);
              from.append('syncChart', this.ruleForm.syncChart ? 1 : 0);
              this.$Http_Post('/activitymanagement/uponlineevent', from, {'Content-Type':'multipart/form-data'}).then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                  this.anload = false;
                  this.Global.request_successful(res.Message);
                  this.dialogVisible = false;
                  this.loading();
                } else {
                  this.anload = false;
                  this.Global.request_failure(res.Message);
                }
              })
            }
          } else {
            return false;
          }
        });
      },
      submitForm2(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addcourseloading = true;
            this.ruleForm2.eventKey=this.currentEventKey; 
            if (this.tits3 == "立即创建") { 
              var from = new FormData(); 
              from.append('fbShiping', this.ruleForm2.fbShiping.raw);
              from.append('eventKey', this.ruleForm2.eventKey);
              from.append('fileNM', this.ruleForm2.fileNM);
              from.append('duration', this.ruleForm2.duration);
              from.append('fileType', this.ruleForm2.fileType);
              this.$Http_Post('/activitymanagement/addeventattach', from, { 'Content-Type': 'multipart/form-data' }).then((res) => {
                this.addcourseloading = false;
                if (res.Code == 200 || res.Code == 0) {
                  this.Global.request_successful(res.Message);
                  this.dialogVisible2 = false;
                  this.loading2();
                } else { 
                  this.Global.request_failure(res.Message);
                }
              })
            } else {
              var from = new FormData();
              from.append('fbShiping', this.ruleForm2.fbShiping.raw);
              from.append('eventKey', this.ruleForm2.eventKey);
              from.append('fileNM', this.ruleForm2.fileNM);
              from.append('duration', this.ruleForm2.duration);
              from.append('fileType', this.ruleForm2.fileType);
              from.append('eventAttachKey', this.eventAttachKey);
              this.$Http_Post('/activitymanagement/upeventattach', from, { 'Content-Type': 'multipart/form-data' }).then((res) => {
                this.addcourseloading = false;
                if (res.Code == 200 || res.Code == 0) {
                  this.Global.request_successful(res.Message);
                  this.dialogVisible2 = false;
                  this.loading2();
                } else {
                  this.Global.request_failure(res.Message);
                }
              })
            }
          } else {
            return false;
          }
        });
      },


      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => { });
      },

      videohandleAvatarSuccess(res, file) {
        // this.imageUrl = URL.createObjectURL(file.raw);
      },
      videohandleChange(file, fileList) {
        this.ruleForm2.fbShiping = file
        this.fileNMs = file.name
        // if (file.raw.type == 'audio/mpeg' || file.raw.type == 'audio/mp3' || file.raw.type == 'audio/wma' || file.raw.type == 'audio/wav' || file.raw.type == 'audio/amr' || file.raw.type == 'audio/m4a') {
        //   this.videoFile = file;

        // } else {
        //   this.$message({ type: 'error', message: '文件格式错误，请上传音频' })
        // }
      },


      handleChange(file, fileList) {
        if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/gif' || file.raw.type == 'image/png') {
          this.imageUrl = URL.createObjectURL(file.raw);
          this.ruleForm.coverPath = file;
        } else {
          this.$message({ type: 'error', message: '文件格式错误，请上传图片' })
        }
      },
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 8
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
        }
        return isLt2M
      },
    },

    resetForm(formName) {
  
    },
    mounted() {
      this.loading()
      this.$Http_Post('User/GetDictionaryList ', { DicTypCode: 44 }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.campus_list = res.Data;
        } else {

        }
      })
    },
  };
</script>
<style>
  .Activity_released{width: 100%;height: 100%;}
  .Activity_selfhelp{height: 100%;}
  .Activity_selfhelp .Activity_selfhelp_top{background-color: #fff;padding: 14px;}
  .Activity_selfhelp .Activity_selfhelp_nav .Activity_selfhelp_nav_top{margin-left: 20px;}
  .Activity_released .avatar-uploader .el-upload:hover {border-color: #409eff;}
  .Activity_released .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
    .avatar {width: 215px;height: 148px;display: block;}
  .cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 175px;}
  .Activity_released .avatar-uploader {position: absolute;top: 0px;left: 0px;}
  .cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 330px;width: 350px;}
  .scale {margin-top: 30px;max-height: 333px;overflow: overlay;}
  .scale,.scale0 {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;max-height: 333px;overflow: overlay;}

  .Activity_selfhelp thead th{background-color: rgba(206, 210, 214, 1) !important;color: rgba(40, 40, 40, 1);}
</style>